import { render, staticRenderFns } from "./audioComment.vue?vue&type=template&id=c7cb64f2&lang=pug&"
import script from "./audioComment.vue?vue&type=script&lang=js&"
export * from "./audioComment.vue?vue&type=script&lang=js&"
import style0 from "./audioComment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports